import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import CaseList, { DispatchProps, OwnProps, StateProps } from './CaseList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getCaseNoConsents, getCaseNoConsentsCsv } from 'src/store/actions/caseNoConsent-actions';
import { selectNameVendors } from 'src/store/selectors/vendors-selectors';
import { selectNameDistricts } from 'src/store/selectors/districts-selectors';
import { getVendorsSmall } from 'src/store/actions/vendor-actions';
import { getDistrictsSmall } from 'src/store/actions/district-actions';
import { selectNameProviders } from '../../../../../store/selectors/providers-selectors';
import { getProvidersSmall } from '../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.casesNoConsent.data,
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getCaseNoConsents(params)),
        getDataCsv: (params: QueryParams) => dispatch(getCaseNoConsentsCsv(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
    };
}

const CaseListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CaseList);

export default CaseListScreen;
